import type { UserProfile } from "oidc-client-ts";
import { useAuth } from "react-oidc-context";

export function useGetCurrentUserProfile(): UserProfile | null {
	const auth = useAuth();
	if (!auth.user) {
		return null;
	}
	return auth.user.profile;
}
